
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/gangwon-facility/[id]",
      function () {
        return require("private-next-pages/gangwon-facility/[id]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/gangwon-facility/[id]"])
      });
    }
  